<template>
	<div class="mb-4">
		<v-card class="mb-3"
			color="grey lighten-1"
			justify-center>
			<br>

			<div class="text-xs-center mt-3 mb-3">
				<h2>Dane konta głównego</h2>
			</div>

			<v-container grid-list-md text-xs-center>
				<v-layout row wrap justify-center>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="email"
							data-vv-name="email"
							data-vv-as="E-mail"
							:error-messages="vErrors.collect('scope5.email')"
							label="E-mail *"
							aria-label="label for email used for logging in"
							for="step-user-data-component-email"
							id="step-user-data-component-email"
							v-model="stepData.email"
							v-validate="'required|email'"
							data-vv-validate-on="none"
							data-vv-scope="scope5"
							class="text-xs-center"
							hint="E-mail będzie wykorzystywany jako login"
							persistent-hint>
						</v-text-field>
					</v-flex>
					<v-flex xs3>
					</v-flex>

					<v-container fluid>
						<div class="text-xs-center mt-3 mb-3">
							<h2>Dane administratora konta</h2>
						</div>
					</v-container>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="given-name"
							data-vv-name="name"
							data-vv-as="Imię"
							:error-messages="vErrors.collect('scope5.name')"
							label="Imię *"
							aria-label="label for name"
							for="step-user-data-component-name"
							id="step-user-data-component-name"
							v-model="stepData.name"
							v-validate="'required'"
							data-vv-scope="scope5"
							class="text-xs-center">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
					</v-flex>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="family-name"
							data-vv-name="surname"
							data-vv-as="Nazwisko"
							:error-messages="vErrors.collect('scope5.surname')"
							label="Nazwisko *"
							aria-label="label for surname"
							for="step-user-data-component-surname"
							id="step-user-data-component-surname"
							v-model="stepData.surname"
							v-validate="'required'"
							data-vv-scope="scope5"
							class="text-xs-center">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
					</v-flex>
					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="tel"
							data-vv-name="phoneNumber"
							data-vv-as="Telefon kontaktowy"
							:error-messages="vErrors.collect('scope5.phoneNumber')"
							label="Telefon kontaktowy *"
							aria-label="label for phone number"
							for="step-user-data-component-phone-number"
							id="step-user-data-component-phone-number"
							v-model="stepData.phoneNumber"
							v-validate="{required: true, regex: /^([(][0-9 +-]*[)])?[0-9 +-]*$/}"
							data-vv-validate-on="none"
							data-vv-scope="scope5"
							class="text-xs-center">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
					</v-flex>
					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="email"
							data-vv-name="bidderContactMail"
							data-vv-as="E-mail kontaktowy"
							:error-messages="vErrors.collect('scope5.bidderContactMail')"
							label="E-mail kontaktowy *"
							aria-label="label for contact email"
							for="step-user-data-component-contact-email"
							id="step-user-data-component-contact-email"
							v-model="stepData.bidderContactMail"
							v-validate="'required|email'"
							data-vv-validate-on="none"
							data-vv-scope="scope5"
							class="text-xs-center">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
					</v-flex>
					<v-container fluid>
						<v-checkbox
							browser-autocomplete="off"
							data-vv-name="rodoCheckbox"
							data-vv-as="zgody przetwarzania danych osobowych"
							aria-label="label for terms and conditions"
							for="step-user-data-component-rodo"
							id="step-user-data-component-rodo"
							class="step-user-data-component-checkbox"
							:error-messages="vErrors.collect('scope5.rodoCheckbox')"
							v-validate="'required'"
							:true-value="true"
							:false-value="null"
							data-vv-validate-on="none"
							data-vv-scope="scope5"
							v-model="checkbox1.status">
							<span slot="label" style="color: black;">
								Wyrażam zgodę na przetwarzanie przez Ministerstwo Spraw Zagranicznych danych zawartych w formularzu rejestracyjnym, dla potrzeb związanych z utworzeniem konta w aplikacji https://egranty.msz.gov.pl, zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (Dz. Urz. UE L 119 z 04.05.2016).
								<span style="color: red">*</span>
							</span>
						</v-checkbox>
						<v-checkbox
							browser-autocomplete="off"
							class="step-user-data-component-checkbox"
							v-model="checkbox2.status"
							data-vv-name="statusCheckbox"
							data-vv-as="zgody Regulaminu"
							:error-messages="vErrors.collect('scope5.statusCheckbox')"
							v-validate="'required'"
							:true-value="true"
							:false-value="null"
							data-vv-validate-on="none"
							data-vv-scope="scope5"
							aria-label="label for terms and conditions"
							for="step-user-data-component-terms-and-conditions"
							id="step-user-data-component-terms-and-conditions">
							<span slot="label" style="color: black;">Akceptuję treść <a target="_blank"
								rel="noopener noreferrer"
								:href="`${publicPath}eGranty - regulamin_aplikacji.pdf`" download>Regulaminu</a> korzystania  z aplikacji konkursowej i oświadczam, że zapoznałam/em się z zawartą w nim informacją o przetwarzaniu moich danych osobowych. <span
									style="color: red">*</span>
							</span>
						</v-checkbox>
					</v-container>
				</v-layout>
			</v-container>
		</v-card>
		<v-btn
			@click="$emit('step', 4)"
			color="blue">Wstecz
		</v-btn>
		<v-btn
			color="primary"
			@click="$emit('step', 6, 'scope5')">
			Rejestruj
		</v-btn>
		<br/>
		<br/>
	</div>
</template>

<script>

	export default {
		name: "StepUserDataComponent",
		inject: ["parentValidator"],

		created() {
			this.$validator = this.parentValidator;
		},

		data() {
			return {
				checkbox1: {
					status: null,
				},
				checkbox2: {
					status: null,
				},
				publicPath: process.env.BASE_URL
			};
		},

		props: {
			stepData: Object,
		},
	};
</script>

<style>
	.step-user-data-component-checkbox .v-input__control,
	.step-user-data-component-checkbox .v-input__slot {
		width: 100% !important;
	}

	.step-user-data-component-checkbox span,
	.step-user-data-component-checkbox span a {
		font-size: 16px;
	}
</style>
